const maneStockMap = {"manemajesty-clip-in-straight":{"49288709112065":true,"49288709144833":true,"49288709177601":true,"49288709210369":true,"49288709243137":true,"49288709275905":true,"49288709308673":true,"49288709341441":true,"49288709374209":true},"manemajesty-1c-curly":{"49288709898497":false,"49288709931265":true,"49288709964033":true},"manemajesty-2-5-star-s":{"49288710029569":false,"49288710062337":true,"49288710095105":false,"49288710127873":true,"49288710160641":true,"49288710193409":true,"49288710226177":true,"49288710258945":true,"49288710291713":false,"49288710324481":true,"49288710357249":true,"49288710390017":true,"49288710422785":true,"49288710455553":true,"49288710488321":true,"49288710521089":true,"49288710553857":true,"49288710586625":true,"49288710619393":true,"49288710652161":true,"49288710684929":true,"49288710717697":false,"49288710750465":true},"manemajesty-5c-water-wave":{"49288710816001":true,"49288710848769":true},"manemajesty-ft-2114-straight":{"49288710881537":false},"manemajesty-ft-2116-curly":{"49288710947073":true},"manemajesty-ft-2117-body-wave":{"49288711012609":false},"manemajesty-ft-2211-deep-curly":{"49288711078145":true,"49288711110913":true,"49288711143681":false,"49288711176449":true,"49288711209217":true,"49288711241985":true,"49288711274753":true},"manemajesty-ft-1229-body-wave":{"49288711307521":false,"49288711340289":false,"49288711373057":false,"49288711405825":true,"49288711438593":true,"49288711471361":true,"49288711504129":true,"49288711536897":true,"49288711569665":true,"49288711602433":true,"49288711635201":true,"49288711667969":true,"49288711700737":true,"49288711733505":true,"49288711766273":true,"49288711799041":true},"manemajesty-ft-1272-body-wave":{"49288711864577":false},"manemajesty-ft-1280-straight":{"49288711897345":true,"49288711930113":false,"49288711962881":false},"manemajesty-ft-1335-curly":{"49288712028417":true},"manemajesty-ft-1339-body-wave":{"49288712061185":false,"49288712093953":true},"manemajesty-ft-1409-curly":{"49288712159489":true},"manemajesty-ft-1525-deep-curly":{"49288712225025":true},"manemajesty-ft-1555-curly":{"49288712257793":false,"49288712290561":true,"49288712323329":true,"49288712356097":true},"manemajesty-ft-1580-straight":{"49288712388865":false,"49288712421633":true},"manemajesty-ft-1614-jerry-curly":{"49288712552705":true,"49288712585473":true},"manemajesty-ft-1710-human-hair-wig":{"49288712651009":true,"49288712683777":false,"49288712716545":true},"manemajesty-ft-1710-straight":{"49288712749313":true},"manemajesty-ft-1794-straight":{"49288713437441":true,"49288713470209":true},"manemajesty-ft-1800-jerry-curly":{"49288713535745":true,"49288713568513":false,"49288713601281":true,"49288713634049":true},"manemajesty-ft-1800-kinky-curly":{"49288713666817":false,"49288713699585":true,"49288713732353":true},"manemajesty-ft-1800-curly":{"49288713765121":true,"49288713797889":true},"manemajesty-ft-1845-body-wave":{"49288713863425":true,"49288713896193":true},"manemajesty-ft-1861-body-wave":{"49288713928961":true},"manemajesty-ft-1862-water-wave":{"49288713961729":true},"manemajesty-ft-1863-curly":{"49288714027265":false,"49288714060033":false},"manemajesty-ft-1930-deep-curly":{"49288714092801":true,"49288714125569":false,"49288714158337":true,"49288714191105":false,"49288714223873":true,"49288714256641":true,"49288714289409":false},"manemajesty-ft-1940-loose-wave":{"49288714322177":true,"49288714354945":true},"manemajesty-ft-1961-straight":{"49288714420481":true,"49288714453249":false},"manemajesty-ft-1962-deep-curly":{"49288714518785":false,"49288714551553":true},"manemajesty-ft-1963-deep-curly":{"49288714944769":true},"manemajesty-ft-1965-kinky-curly":{"49288715075841":true,"49288715108609":true},"manemajesty-ft-2068-wet-and-wavy":{"49288715206913":false,"49288715239681":true,"49288715272449":false,"49288715305217":true,"49288715337985":true,"49288715370753":true},"manemajesty-ft-2072-human-hair-wig":{"49288715403521":true},"manemajesty-ft-2072-body-wave":{"49288715469057":false,"49288715501825":true,"49288715534593":false,"49288715567361":true,"49288715600129":true,"49288715632897":false,"49288715665665":true,"49288715698433":true,"49288715731201":true,"49288715763969":true,"49288715796737":true,"49288715829505":true,"49288715862273":true,"49288715895041":true,"49288715927809":true},"manemajesty-ft-2076-straight":{"49288716026113":true},"manemajesty-ft-2077-deep-wave":{"49288716091649":true},"manemajesty-ft-2079-body-wave":{"49288716124417":true},"manemajesty-ft-2082-kinky-curly":{"49288716189953":true},"manemajesty-ft-2083-deep-curly":{"49288716222721":true,"49288716255489":true},"manemajesty-ft-2083-curly":{"49288716288257":true,"49288716321025":true,"49288716353793":true},"manemajesty-ft-2083-jerry-curly":{"49288716452097":true,"49288716484865":true},"manemajesty-ft-2086-curly-wave":{"49288716976385":true,"49288717009153":true,"49288717041921":true,"49288717074689":true,"49288717107457":true},"manemajesty-ft-2087-kinky-curly":{"49288717172993":true,"49288717205761":false,"49288717238529":true,"49288717271297":true,"49288717304065":false},"manemajesty-ft-2131-kinky-curly":{"49288717435137":false,"49288717467905":false},"manemajesty-ft-2147-straight":{"49288717533441":false,"49288717566209":true,"49288717598977":true,"49288717631745":true,"49288717664513":true},"manemajesty-ft-2167-yaki-straight":{"49288717697281":true,"49288717730049":true,"49288717762817":true,"49288717795585":false,"49288717828353":true,"49288717861121":true,"49288717893889":true},"manemajesty-ft-2169-wet-and-wavy":{"49288717926657":true,"49288717959425":true},"manemajesty-ft-2169-body-wave":{"49288718024961":true},"manemajesty-ft-2170-wet-and-wavy":{"49288718057729":true,"49288718090497":false,"49288718123265":true},"manemajesty-ft-2172-yaki-straight":{"49288718156033":true,"49288718188801":true,"49288718221569":false,"49288718254337":true,"49288718287105":true},"manemajesty-ft-2178-deep-curly":{"49288718352641":false,"49288718385409":true,"49288718418177":true,"49288718450945":true,"49288718483713":true,"49288718516481":true,"49288718549249":true},"manemajesty-ft-2180-kinky-curly":{"49288718614785":true},"manemajesty-ft-2180-jerry-curly":{"49288718647553":true},"manemajesty-ft-2184-straight":{"49288718680321":true,"49288718713089":true},"manemajesty-ft-2187-kinky-curly":{"49288718778625":true,"49288718811393":false,"49288718844161":true,"49288718876929":true},"manemajesty-ft-2187-deep-wave":{"49288718909697":true,"49288718942465":true},"manemajesty-ft-2210-straight":{"49288718975233":true,"49288719008001":false,"49288719040769":false,"49288719073537":true,"49288719106305":true,"49288719139073":false},"manemajesty-ft-2212-wet-and-wavy":{"49288719171841":true,"49288719204609":true,"49288719237377":false,"49288719270145":true,"49288719302913":false,"49288719335681":true},"manemajesty-ft-2213-body-wave":{"49288719401217":true,"49288719433985":true,"49288719466753":false,"49288719499521":true,"49288719532289":true,"49288719565057":true,"49288719597825":true},"manemajesty-ft-2220-straight":{"49288719630593":true,"49288719663361":true,"49288719696129":true,"49288719728897":true,"49288719761665":true,"49288719794433":true},"manemajesty-ft-2221-loose-wave":{"49288719827201":true,"49288719859969":true,"49288719892737":true,"49288719925505":true,"49288719958273":true,"49288719991041":true},"manemajesty-ft-2222-deep-wave":{"49288720023809":true,"49288720056577":true,"49288720089345":true,"49288720122113":true,"49288720154881":true,"49288720187649":true},"manemajesty-ft-2223-body-wave":{"49288720220417":true,"49288720253185":true,"49288720285953":true,"49288720318721":true,"49288720351489":true,"49288720384257":true},"manemajesty-ft-2285-wet-and-wavy":{"49288720449793":true,"49288720482561":true,"49288720515329":true,"49288720548097":false,"49288720580865":true},"manemajesty-ft-2292-wet-and-wavy":{"49288721072385":true,"49288721105153":true,"49288721137921":true,"49288721170689":true,"49288721203457":false},"manemajesty-ft-2308-straight":{"49288721268993":true,"49288721301761":false,"49288721334529":true,"49288721367297":false,"49288721400065":false,"49288721432833":true,"49288721465601":true},"manemajesty-ft-2312-water-wave":{"49288721563905":false,"49288721596673":true},"manemajesty-ft-2312-deep-wave":{"49288721694977":true,"49288721727745":true},"manemajesty-ft-2326-kinky-curly":{"49288721826049":true,"49288721858817":true,"49288721891585":true,"49288721924353":true},"manemajesty-ft-2327-body-wave":{"49288721989889":false,"49288722022657":true,"49288722055425":false,"49288722088193":true},"manemajesty-ft-2366-straight":{"49288722219265":true},"manemajesty-ft-2510-curly":{"49288722317569":false,"49288722350337":true,"49288722383105":true,"49288722415873":true},"manemajesty-ft-2589-human-hair-wig":{"49288722546945":false,"49288722579713":true},"manemajesty-ft-2590-deep-wave":{"49288722645249":true,"49288722678017":true},"manemajesty-ft-2592-body-wave":{"49288722776321":true,"49288722809089":true},"manemajesty-ft-2608-kinky-curly":{"49288722907393":true,"49288722940161":true,"49288722972929":true},"manemajesty-ft-2653-body-wave":{"49288723071233":false,"49288723104001":false,"49288723136769":false,"49288723169537":false,"49288723202305":true,"49288723235073":false,"49288723267841":true,"49288723300609":true,"49288723333377":false,"49288723366145":true,"49288723398913":true},"manemajesty-ft-2690-body-wave":{"49288723562753":true},"manemajesty-ft-2691-straight":{"49288723628289":true},"manemajesty-ft-2692-curly-wave":{"49288723661057":true},"manemajesty-ft-2740-kinky-curly":{"49288723693825":true,"49288723726593":true,"49288723759361":true,"49288723792129":true},"manemajesty-ft-2835-body-wave":{"49288723857665":false,"49288723890433":false,"49288723923201":false,"49288723955969":false,"49288723988737":false,"49288724021505":false,"49288724054273":false},"manemajesty-ft-2291-straight":{"49288724087041":true,"49288724119809":true,"49288724152577":true,"49288724185345":false,"49288724218113":false,"49288724250881":true,"49288724283649":true,"49288724316417":true},"manemajesty-glossy-body":{"49288724381953":true,"49288724414721":true,"49288724447489":true,"49288724480257":false,"49288724513025":true,"49288724545793":true},"manemajesty-glossy-straight":{"49288724578561":true,"49288724611329":true,"49288724644097":true,"49288724676865":true,"49288724709633":true,"49288724742401":true,"49288724775169":true},"manemajesty-kc-kinky-curly":{"49288724840705":true,"49288724873473":true},"manemajesty-ft-1789-yaki-straight":{"49288725364993":true},"manemajesty-ft-2091-body-wave":{"49288725397761":true,"49288725430529":true,"49288725463297":true,"49288725496065":true}};

const products = [
  {
    id: "glueless-wave",
    name: "Everyday Glueless Body Wave Wig",
    type: "glueless",
    detail: "Pre-plucked hairline, 180% density, adjustable beginner cap.",
    tag: "Glueless",
    length: "18 in",
    price: 189,
  },
  {
    id: "clean-bob",
    name: "Clean Part Human Hair Bob Wig",
    type: "bob",
    detail: "Natural movement, shoulder-skimming shape, workday polish.",
    tag: "Bob",
    length: "12 in",
    price: 129,
  },
  {
    id: "soft-bangs",
    name: "Soft Bangs Straight Human Hair Wig",
    type: "glueless",
    detail: "Face-framing fringe with a secure cap for easy daily styling.",
    tag: "Bangs",
    length: "16 in",
    price: 159,
  },
  {
    id: "lace-front",
    name: "Natural Lace Front Deep Wave Wig",
    type: "lace",
    detail: "Flexible parting, soft lace finish, full-looking deep wave texture.",
    tag: "Lace",
    length: "20 in",
    price: 219,
  },
];

const state = {
  filter: "all",
  cart: [],
};

const productGrid = document.querySelector("[data-product-grid]");
const filterButtons = document.querySelectorAll("[data-filter]");
const cartDrawer = document.querySelector("[data-cart-drawer]");
const cartOpen = document.querySelector("[data-cart-open]");
const cartClose = document.querySelector("[data-cart-close]");
const cartCount = document.querySelector("[data-cart-count]");
const cartItems = document.querySelector("[data-cart-items]");
const cartEmpty = document.querySelector("[data-cart-empty]");
const cartTotal = document.querySelector("[data-cart-total]");
const revealItems = document.querySelectorAll(".reveal-on-scroll");

function formatPrice(value) {
  return `$${value.toFixed(0)}`;
}

function getVisibleProducts() {
  if (state.filter === "all") {
    return products;
  }

  return products.filter((product) => product.type === state.filter);
}

function renderProducts() {
  if (!productGrid) {
    return;
  }

  productGrid.innerHTML = getVisibleProducts()
    .map(
      (product) => `
        <article class="product-card">
          <div class="product-image" role="img" aria-label="${product.name}"></div>
          <div class="product-body">
            <div class="product-meta">
              <span>${product.tag}</span>
              <span>${product.length}</span>
            </div>
            <h3>${product.name}</h3>
            <p>${product.detail}</p>
            <div class="product-bottom">
              <span class="price">${formatPrice(product.price)}</span>
              <button class="add-button" type="button" data-add="${product.id}" aria-label="Add ${product.name} to cart">+</button>
            </div>
          </div>
        </article>
      `,
    )
    .join("");
}

function renderCart() {
  const subtotal = state.cart.reduce((sum, item) => sum + item.price * item.qty, 0);
  const count = state.cart.reduce((sum, item) => sum + item.qty, 0);

  if (cartCount) {
    cartCount.textContent = count;
  }

  if (cartTotal) {
    cartTotal.textContent = formatPrice(subtotal);
  }

  if (cartEmpty) {
    cartEmpty.style.display = state.cart.length ? "none" : "block";
  }

  if (!cartItems) {
    return;
  }

  cartItems.innerHTML = state.cart
    .map(
      (item) => `
        <div class="cart-item">
          <div class="cart-thumb" aria-hidden="true"></div>
          <div>
            <strong>${item.name}</strong>
            <span>${item.qty} × ${formatPrice(item.price)}</span>
          </div>
          <strong>${formatPrice(item.price * item.qty)}</strong>
        </div>
      `,
    )
    .join("");
}

function addToCart(productId) {
  const product = products.find((item) => item.id === productId);
  const existing = state.cart.find((item) => item.id === productId);

  if (!product) {
    return;
  }

  if (existing) {
    existing.qty += 1;
  } else {
    state.cart.push({ ...product, qty: 1 });
  }

  renderCart();
  openCart();
}

function openCart() {
  if (!cartDrawer) {
    return;
  }

  cartDrawer.classList.add("is-open");
  cartDrawer.setAttribute("aria-hidden", "false");
}

function closeCart() {
  if (!cartDrawer) {
    return;
  }

  cartDrawer.classList.remove("is-open");
  cartDrawer.setAttribute("aria-hidden", "true");
}

function setupCartRemoveButtons() {
  document.querySelectorAll("[data-cart-remove]").forEach((link) => {
    if (link.dataset.removeReady === "true") {
      return;
    }

    link.dataset.removeReady = "true";
    link.addEventListener("click", async (event) => {
      const line = Number(link.dataset.cartLine);

      if (!line || typeof fetch !== "function") {
        return;
      }

      event.preventDefault();
      link.dataset.defaultText = link.textContent;
      link.textContent = "Removing...";
      link.setAttribute("aria-disabled", "true");

      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ line, quantity: 0 }),
        });

        if (!response.ok) {
          throw new Error("Cart remove failed");
        }

        window.location.reload();
      } catch (error) {
        window.location.href = link.href;
      }
    });
  });
}

filterButtons.forEach((button) => {
  button.addEventListener("click", () => {
    state.filter = button.dataset.filter;
    filterButtons.forEach((item) => item.classList.toggle("is-active", item === button));
    renderProducts();
  });
});

if (productGrid) {
  productGrid.addEventListener("click", (event) => {
    const button = event.target.closest("[data-add]");
    if (!button) {
      return;
    }

    addToCart(button.dataset.add);
  });
}

document.querySelectorAll(".faq-item").forEach((button) => {
  button.addEventListener("click", () => {
    const panel = button.nextElementSibling;
    const indicator = button.querySelector("span:last-child");
    const willOpen = !panel.classList.contains("is-open");

    panel.classList.toggle("is-open", willOpen);
    indicator.textContent = willOpen ? "−" : "+";
  });
});

if (cartOpen) {
  cartOpen.addEventListener("click", openCart);
}

if (cartClose) {
  cartClose.addEventListener("click", closeCart);
}

if (cartDrawer) {
  cartDrawer.addEventListener("click", (event) => {
    if (event.target === cartDrawer) {
      closeCart();
    }
  });
}

if (revealItems.length) {
  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16 },
    );

    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add("is-visible"));
  }
}

document.querySelectorAll(".product-form").forEach((form) => {
  const variantsSource = document.querySelector("[data-product-variants]");
  const optionGroups = Array.from(form.querySelectorAll("[data-option-group]")).map((group) => {
    const position = Number(group.dataset.optionPosition);

    return {
      element: group,
      position,
      index: position - 1,
      controls: Array.from(group.querySelectorAll("[data-option-value]")),
    };
  });
  const variantInput = form.querySelector("#VariantId");
  const submitButton = form.querySelector(".product-submit");
  const buyNowButton = form.querySelector("[data-buy-now]");
  const cartMessage = form.querySelector("[data-cart-message]");
  const status = form.querySelector("[data-variant-status]");
  const skuLabel = document.querySelector("[data-variant-sku]");
  const skuValue = skuLabel ? skuLabel.querySelector("span") : null;
  const priceLabel = document.querySelector("[data-variant-price]");
  const gallery = document.querySelector("[data-product-gallery]");
  const galleryItems = gallery ? Array.from(gallery.querySelectorAll("[data-gallery-item]")) : [];
  const primaryGalleryItem = galleryItems.find((item) => item.hasAttribute("data-gallery-primary")) || galleryItems[0];
  const productHandle = form.dataset.productHandle;
  const cartAddUrl = form.dataset.cartAddUrl || "/cart/add";
  const checkoutUrl = form.dataset.checkoutUrl || "/checkout";

  if (!variantsSource || !variantInput || !submitButton) {
    return;
  }

  let variants = [];
  let selectedVariant = null;

  try {
    variants = JSON.parse(variantsSource.textContent);
  } catch (error) {
    return;
  }

  function getVariantKey(variant) {
    return String(variant.id).replace("gid://shopify/ProductVariant/", "");
  }

  function isPurchasable(variant) {
    if (!variant) {
      return false;
    }

    return Boolean(variant.available || variant.inventory_policy === "continue");
  }

  function getCartAddJsonUrl() {
    return cartAddUrl.endsWith(".js") ? cartAddUrl : `${cartAddUrl}.js`;
  }

  function setCartMessage(message, type) {
    if (!cartMessage) {
      return;
    }

    cartMessage.textContent = message;
    cartMessage.hidden = !message;
    cartMessage.classList.toggle("is-error", type === "error");
  }

  function updateLiveCartCount(count) {
    document.querySelectorAll(".cart-count, [data-cart-count]").forEach((badge) => {
      badge.textContent = count;
    });
  }

  async function refreshCartCount() {
    if (typeof fetch !== "function") {
      return;
    }

    const response = await fetch(`/cart.js?cart_count=${Date.now()}`, {
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      return;
    }

    const cart = await response.json();
    updateLiveCartCount(cart.item_count || 0);
  }

  function setPurchaseLoading(button, loading) {
    if (!button) {
      return;
    }

    if (loading) {
      button.dataset.defaultText = button.textContent;
      button.textContent = "Adding...";
      button.disabled = true;
      return;
    }

    button.textContent = button.dataset.defaultText || button.textContent;
    button.disabled = !isPurchasable(selectedVariant);
  }

  async function addSelectedVariantToCart() {
    if (!isPurchasable(selectedVariant)) {
      throw new Error("This option is sold out.");
    }

    const formData = new FormData(form);
    formData.set("id", variantInput.value);

    if (!formData.has("quantity")) {
      formData.set("quantity", "1");
    }

    const response = await fetch(getCartAddJsonUrl(), {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      let message = "Could not add this item to cart.";

      try {
        const error = await response.json();
        message = error.description || error.message || message;
      } catch (parseError) {
        message = response.statusText || message;
      }

      throw new Error(message);
    }

    await refreshCartCount();
  }

  function normalizeToken(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "");
  }

  function mediaMatchesVariant(item, variant) {
    if (!item || !variant) {
      return false;
    }

    const mediaId = item.dataset.mediaId || "";
    const mediaAlt = item.dataset.mediaAlt || "";
    const sku = variant.sku || "";

    if (variant.featured_media_id && mediaId && String(mediaId) === String(variant.featured_media_id)) {
      return true;
    }

    if (!sku || !mediaAlt) {
      return false;
    }

    const altLower = mediaAlt.toLowerCase();
    const skuLower = sku.toLowerCase();
    return altLower.includes(skuLower) || normalizeToken(mediaAlt).includes(normalizeToken(sku));
  }

  function updateGallery(variant) {
    if (!gallery || galleryItems.length === 0) {
      return;
    }

    if (variant && variant.featured_media_url && primaryGalleryItem) {
      const image = primaryGalleryItem.querySelector("img");

      if (image) {
        image.src = variant.featured_media_url;
        image.removeAttribute("srcset");
        image.alt = variant.featured_media_alt || variant.sku || image.alt;
      }

      if (variant.featured_media_id) {
        primaryGalleryItem.dataset.mediaId = String(variant.featured_media_id);
      }

      if (variant.featured_media_alt || variant.sku) {
        primaryGalleryItem.dataset.mediaAlt = variant.featured_media_alt || variant.sku;
      }
    }

    const matches = variant ? galleryItems.filter((item) => mediaMatchesVariant(item, variant)) : [];
    const shouldFilterToMatches = matches.length >= 3;

    galleryItems.forEach((item, index) => {
      item.hidden = shouldFilterToMatches && !matches.includes(item);
      item.classList.remove("is-selected-media");
      item.style.order = String(1000 + Number(item.dataset.galleryDefaultIndex || index));
    });

    if (matches.length === 0) {
      return;
    }

    matches.forEach((item, index) => {
      const isFeatured =
        variant &&
        variant.featured_media_id &&
        item.dataset.mediaId &&
        String(item.dataset.mediaId) === String(variant.featured_media_id);
      item.style.order = String(isFeatured ? 0 : index + 1);
      item.classList.toggle("is-selected-media", index === 0 || isFeatured);
    });
  }

  function getSelectedOptions() {
    return optionGroups
      .map((group) => {
        const selectedControl =
          group.controls.find((control) => control.classList.contains("is-selected")) || group.controls[0];

        return {
          index: group.index,
          value: selectedControl ? selectedControl.dataset.optionValue : "",
        };
      })
      .filter((option) => option.value !== "");
  }

  function findSelectedVariant() {
    const selectedOptions = getSelectedOptions();

    const matchingVariants = variants.filter((variant) => {
      if (!Array.isArray(variant.options)) {
        return false;
      }

      return selectedOptions.every((option) => variant.options[option.index] === option.value);
    });

    return matchingVariants[0];
  }

  function findFallbackVariant(changedControl) {
    const changedIndex = changedControl ? Number(changedControl.dataset.optionPosition) - 1 : -1;
    const changedValue = changedControl ? changedControl.dataset.optionValue : "";

    if (changedIndex >= 0) {
      const matchingAvailableVariant = variants.find((variant) => {
        return isPurchasable(variant) && variant.options && variant.options[changedIndex] === changedValue;
      });

      if (matchingAvailableVariant) {
        return matchingAvailableVariant;
      }

      const matchingVariant = variants.find((variant) => {
        return variant.options && variant.options[changedIndex] === changedValue;
      });

      if (matchingVariant) {
        return matchingVariant;
      }
    }

    return variants.find(isPurchasable) || variants[0];
  }

  function syncOptionControls(variant) {
    if (!variant || !Array.isArray(variant.options)) {
      return;
    }

    optionGroups.forEach((group) => {
      const value = variant.options[group.index];

      if (value !== undefined) {
        group.controls.forEach((control) => {
          const selected = control.dataset.optionValue === value;
          control.classList.toggle("is-selected", selected);
          control.setAttribute("aria-pressed", selected ? "true" : "false");
        });
      }
    });
  }

  function getVariantForOptionValue(group, value, requirePurchasable, matchCurrentOptions) {
    const selectedOptions = getSelectedOptions();

    return variants.find((variant) => {
      if (!Array.isArray(variant.options)) {
        return false;
      }

      if (requirePurchasable && !isPurchasable(variant)) {
        return false;
      }

      if (variant.options[group.index] !== value) {
        return false;
      }

      if (!matchCurrentOptions) {
        return true;
      }

      return selectedOptions.every((option) => {
        if (option.index === group.index) {
          return true;
        }

        return variant.options[option.index] === option.value;
      });
    });
  }

  function updateOptionControls() {
    optionGroups.forEach((group) => {
      group.controls.forEach((control) => {
        const value = control.dataset.optionValue;
        const hasCurrentPurchasableVariant = getVariantForOptionValue(group, value, true, true);
        const hasAnyVariant = getVariantForOptionValue(group, value, false, false);
        const unavailable = !hasCurrentPurchasableVariant;
        const disabled = !hasAnyVariant;

        control.classList.toggle("is-unavailable", unavailable);
        control.disabled = disabled;
        control.setAttribute("aria-disabled", disabled ? "true" : "false");
      });
    });
  }

  function selectControl(control) {
    const group = optionGroups.find((item) => item.position === Number(control.dataset.optionPosition));

    if (!group) {
      return;
    }

    group.controls.forEach((item) => {
      const selected = item === control;
      item.classList.toggle("is-selected", selected);
      item.setAttribute("aria-pressed", selected ? "true" : "false");
    });
  }

  function updateVariant(changedControl) {
    let variant = findSelectedVariant();

    if (!variant) {
      variant = findFallbackVariant(changedControl);
      syncOptionControls(variant);
    }

    const purchasable = isPurchasable(variant);
    selectedVariant = variant || null;

    updateOptionControls();

    if (variant) {
      variantInput.value = variant.id;

      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", getVariantKey(variant));
        window.history.replaceState({}, "", url);
      }
    }

    if (skuLabel && skuValue) {
      const sku = variant && variant.sku ? variant.sku : "";
      skuValue.textContent = sku;
      skuLabel.hidden = !sku;
    }

    if (priceLabel && variant && variant.price_money) {
      priceLabel.textContent = variant.price_money;
    }

    updateGallery(variant);

    submitButton.disabled = !purchasable;
    submitButton.textContent = purchasable ? "Add to cart" : "Sold out";

    if (buyNowButton) {
      buyNowButton.disabled = !purchasable;
    }

    setCartMessage("", "success");

    if (status) {
      status.textContent = purchasable ? "In stock" : "Sold out";
      status.classList.toggle("is-sold-out", !purchasable);
    }

    form.dispatchEvent(new CustomEvent("variant:change", { bubbles: true, detail: { variant } }));
  }

  async function refreshAvailabilityFromProductJson() {
    if (!productHandle || typeof fetch !== "function") {
      return;
    }

    try {
      const response = await fetch(`/products/${productHandle}.js?stock_check=${Date.now()}`, {
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        return;
      }

      const productJson = await response.json();
      const liveVariants = Array.isArray(productJson.variants) ? productJson.variants : [];
      const liveVariantById = new Map(liveVariants.map((variant) => [String(variant.id), variant]));

      variants = variants.map((variant) => {
        const liveVariant = liveVariantById.get(getVariantKey(variant));

        if (!liveVariant) {
          return variant;
        }

        return {
          ...variant,
          available: Boolean(liveVariant.available),
          price: liveVariant.price ?? variant.price,
          price_money: liveVariant.price ? `$${(Number(liveVariant.price) / 100).toFixed(2)}` : variant.price_money,
        };
      });

      updateVariant();
    } catch (error) {
      // Keep the Liquid-rendered state if Shopify's product JSON endpoint is unavailable.
    }
  }

  optionGroups.forEach((group) => {
    group.controls.forEach((control) => {
      control.addEventListener("click", () => {
        selectControl(control);
        updateVariant(control);
      });
    });
  });

  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    setCartMessage("", "success");
    setPurchaseLoading(submitButton, true);

    try {
      await addSelectedVariantToCart();
      setCartMessage("Added to cart. You can keep shopping or check out when ready.", "success");
    } catch (error) {
      setCartMessage(error.message || "Could not add this item to cart.", "error");
    } finally {
      setPurchaseLoading(submitButton, false);
    }
  });

  if (buyNowButton) {
    buyNowButton.addEventListener("click", async () => {
      setCartMessage("", "success");
      setPurchaseLoading(buyNowButton, true);
      submitButton.disabled = true;

      try {
        await addSelectedVariantToCart();
        window.location.href = checkoutUrl;
      } catch (error) {
        setCartMessage(error.message || "Could not add this item to cart.", "error");
        setPurchaseLoading(buyNowButton, false);
        submitButton.disabled = !isPurchasable(selectedVariant);
      }
    });
  }

  updateVariant();
  refreshAvailabilityFromProductJson();
});

function setupProductBackButton() {
  const productSummary = document.querySelector(".product-summary");

  if (productSummary && !document.querySelector("[data-product-back]")) {
    const eyebrow = productSummary.querySelector(".eyebrow");
    const head = document.createElement("div");
    head.className = "product-summary-head";

    if (eyebrow) {
      productSummary.insertBefore(head, eyebrow);
      head.appendChild(eyebrow);
    } else {
      productSummary.prepend(head);
    }

    const button = document.createElement("button");
    button.className = "product-back-button";
    button.type = "button";
    button.dataset.productBack = "";
    button.textContent = "Back";
    head.appendChild(button);
  }

  document.querySelectorAll("[data-product-back]").forEach((button) => {
    if (button.dataset.backReady === "true") {
      return;
    }

    button.dataset.backReady = "true";
    button.addEventListener("click", () => {
      if (window.history.length > 1 && document.referrer) {
        window.history.back();
        return;
      }

      window.location.href = "/collections/lace-front-wigs";
    });
  });
}

setupProductBackButton();
setupCartRemoveButtons();

renderProducts();
renderCart();
